import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import { UserToken } from '../core/auth/user-token';
import {Observable} from 'rxjs';
import {UsuarioDTO, UsuarioMotoristaParametroDTO} from '../content/pages/components/cadastros/usuario/models/usuario.model';

@Injectable({ providedIn: 'root' })
export class UsuariosService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
		private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/usuarios';
	}

	consultarUsuario(idUsuario) {
		return this.get('/consultar', {
			dados: { id: idUsuario }
		});
	}

	ativarUsuario(usuario: any) {
		return this.post('/ativar', {
			dados: {
				id: usuario.id
			},
			enviarComoQueryString: true
		});
	}

	inativarUsuario(usuario: any) {
		return this.post('/inativar', {
			dados: {
				id: usuario.id
			},
			enviarComoQueryString: true
		});
	}

	getUserToken() {
		return this.get<UserToken>('/getUserToken');
	}

	getAppInfo() {
		return this.get<any>('/app');
	}

	listarComEntrega(usuario) {
		return this.get<any>('/listarComEntrega', {
			dados: { usuario }
		});
	}

	listarComDespesa() {
		return this.get<any[]>('/listarComDespesa');
	}

	listarComEvento() {
		return this.get<any[]>('/listarComEvento');
	}

	listarComHodometros() {
		return this.get<any[]>('/listarComHodometros');
	}

	listarAtivosPortal() {
		return this.get<any[]>('/listarAtivosPortal');
	}

	listarComDescargaCancelada(){
		return this.get<any[]>('/listarComDescargaCancelada');
	}

	listarTipoUsuarios(): Observable<any> {
		return this.get<any[]>('/listarTipoUsuarios');
	}

	tipoUsuarioLogadoAdministrador(idUsuarioLogado: string): Observable<boolean> {
		return this.get<boolean>(`/tipoUsuarioLogadoAdministrador/${idUsuarioLogado}`);
	}

	listarUsuariosByIdFilial(idFilial: string) {
		return this.get<any[]>(`/listarUsuariosFiliais/${idFilial}`);
	}

	listarResponsaveisEMotoristasValidaFiliais() {
		return this.get<UsuarioDTO[]>('/listarResponsaveisEMotoristasValidaFiliais');
	}

	listarUsuariosMotoristaParametroPortalByFilial(idParametro: string, idFilial: string): Observable<UsuarioMotoristaParametroDTO[]> {
		return this.get<UsuarioMotoristaParametroDTO[]>('/listarUsuariosMotoristaParametroPortalByFilial', {
			dados: {
				idParametro,
				idFilial
			}
		});
	}


	listarResponsaveisEMotoristasByCodFilial(filtro) {
		return this.post<UsuarioDTO[]>('/listarResponsaveisEMotoristasByCodFilial', {
			dados: filtro
		});
	}

	listarUsuariosNaoMotoristasValidandoFiliaisByIdUsuario(idUsuario: string) {
		return this.get<UsuarioDTO[]>('/listarUsuariosNaoMotoristasValidandoFiliaisByIdUsuario', {
			dados: {idUsuario}
		});
	}
}
